module.exports = __webpack_public_path__ + "fonts/Mukta-500-devanagari10.29e7e0a.woff2";